import { ActionState } from '@components/Activity/types/ActionState';
import { ActivityState } from '@components/Activity/types/ActivityStates';
import { RiskAssessmentState } from '@components/Activity/types/RiskAssessmentState';
import { TraceabilityState } from '@components/Activity/types/TraceabilityState';
import { Document, Image, Page, Text, View } from '@react-pdf/renderer';
import styles from '../common/styles';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { RiskAssessmentReportAccordian } from './RiskAssessmentReportAccordian';
import { ActivityReportAccordian } from './ActivityReportAccodian';
import { ActionReportAccordian } from './ActionReportAccordian';
import { TraceabilityReportAccordian } from './TraceabilityReportAccordian';
import { useTranslation } from 'react-i18next';

type Props = {
  activityState: ActivityState;
  riskAssessmentState: RiskAssessmentState;
  traceabilityState: TraceabilityState;
  actionState: ActionState;
};

const ActivityReport = ({
  activityState,
  riskAssessmentState,
  traceabilityState,
  actionState,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Image style={styles.imageHSE} src={'/hse.jpg'} />
        <View style={styles.titleBar}>
          <Text>{t('activity.report.page.components.activity.main.title')}</Text>
        </View>
        <ActivityReportAccordian activity={activityState.activity!} />
        <RiskAssessmentReportAccordian riskAssessment={riskAssessmentState.riskAssessment} />
      </Page>
      <Page size="A4" style={styles.page}>
        <ActionReportAccordian actionState={actionState} />
        <TraceabilityReportAccordian traceabilityState={traceabilityState} />
      </Page>
    </Document>
  );
};

export default ActivityReport;
